import { useMemo, useCallback } from 'react';

/**
 * Get CTA variant content based on SEO score
 * @param {number} score - The SEO score (0-100)
 * @returns {Object} CTA content with heading, description, and buttonLabel
 */
const getCtaVariantByScore = (score) => {
  const currentYear = new Date().getFullYear();

  if (score >= 0 && score <= 30) {
    // Very Low
    return {
      heading: "Let's Fix Your SEO — Fast",
      description:
        'Quick wins can lead to major improvements — one client boosted leads by 71% in just one month. Request your custom SEO action plan today!',
      buttonLabel: 'Help Me Fix It',
    };
  } else if (score >= 31 && score <= 50) {
    // Low
    return {
      heading: "You've Got Big SEO Potential",
      description:
        "With a few strategic SEO moves, we helped one business grow organic traffic by 82%. Let's do the same for you. Request your custom SEO strategy today!",
      buttonLabel: 'Get My SEO Growth Plan',
    };
  } else if (score >= 51 && score <= 70) {
    // Medium
    return {
      heading: "Let's take your SEO up a notch!",
      description:
        "You've built a solid foundation — now let's drive even more qualified traffic with strategic SEO that delivers results. Request your custom strategy now!",
      buttonLabel: 'Get My Custom Strategy',
    };
  } else if (score >= 71 && score <= 85) {
    // High
    return {
      heading: 'Good SEO ≠ Great Leads',
      description:
        "You're ranking — but are the right people finding you? We'll help you capture the high-value searches your competitors are still winning.",
      buttonLabel: 'Get More From My SEO',
    };
  } else {
    // Very High (86-100)
    return {
      heading: 'Looking great! Now what?',
      description: `You've nailed the technical side — now let's scale results with AI-focused strategies and next-gen search growth in ${currentYear} with WebFX.`,
      buttonLabel: 'Get My Advanced Strategy',
    };
  }
};

/**
 * Hook for managing CTA content based on SEO score
 * @param {number} score - The SEO score (0-100)
 * @returns {Object} CTA content and submit handler
 */
export const useCtaContent = (score) => {
  // Get CTA variant based on score
  const ctaContent = useMemo(() => getCtaVariantByScore(score), [score]);

  // Handle CTA form submission
  const handleCtaSubmit = useCallback((siteUrl) => {
    console.log('CTA submitted for:', siteUrl);
    // TODO: Implement CTA submission logic
  }, []);

  return {
    heading: ctaContent.heading,
    description: ctaContent.description,
    buttonLabel: ctaContent.buttonLabel,
    handleCtaSubmit,
  };
};

export default useCtaContent;

